export class CreateAssetCommand {
    constructor(asset) {
        this.asset = asset;
    }
}
//# sourceMappingURL=create-asset.command.js.map